import { getSetting } from '@woocommerce/settings';
import { __ } from '@wordpress/i18n';
export const Block = ( { checkoutExtensionData, extensions } ) => {
	const {enable_module, disable_multicart, save_cart_label, replace_cart_label, enable_replace_btn, share_cart_label,
		 is_user_logged_in, disable_btns_status, cart_id}  = getSetting( 'share-cart_data');
		var save_cart_btn, replace_btn;
		 if ( 'yes' == disable_multicart && is_user_logged_in ) {
			if ( 'continue' == disable_btns_status || 'none' == disable_btns_status ) {
				save_cart_btn = <a class="button blocks-btn wsc_save_share_cart">{save_cart_label}</a>
			}
			if ( 'yes' == enable_replace_btn ) {
				if ( null == cart_id ) {
					var style = {display:'none'};
				}
				replace_btn = <a class="button blocks-btn wsc_save_replace_cart" data-cart-id={cart_id} style={style}>{replace_cart_label}</a>
			}
		}
		if ( '' == enable_module ) {
			return;
		}
	return (
		<div className="wp-block-share-cart-buttons">
			<span class="wsc_save_share_cart_btns">
				<a class="button blocks-btn wsc_share_cart" data-cart-id={cart_id}>{share_cart_label}</a>
			{save_cart_btn}{replace_btn}
			</span>
		</div>
	);
};